import { useQuery } from 'react-query';
import { CacheKeys } from '../constants';
import moment from 'moment';
import { useAPI } from './useAPI';
const getInitialData = ({ from, to }) => {
    const format = (date) => moment(date).format('MMMM D, YYYY');
    return [
        { label: from ? format(from) : '', value: 0 },
        { label: to ? format(to) : '', value: 0 }
    ];
};
export const useAnalyticsQuery = (params) => {
    const { get } = useAPI();
    const initialData = getInitialData(params);
    return useQuery([CacheKeys.ANALYTICS, params], () => get({ url: '/transactions/analytics', misc: { params } }).then((res) => res.data), { initialData: initialData });
};
//# sourceMappingURL=useAnalytics.js.map